module.exports = __webpack_public_path__ + "User_Verification.9bf82dd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/portal_icons/User_Verification.png
// module id = 710
// module chunks = 0